import { FC } from 'react';

const CCAVisitReportVerificationCall: FC = () => {
	return 'WIP';
};

export default CCAVisitReportVerificationCall;
